<!-- Header -->
<app-frontend-header [header]="label()">
  <a i18n routerLink="/">Home</a>
  <a i18n routerLink="#">Workshops</a>
  <a routerLink="#" class="text-warn">{{ label() }}</a>
</app-frontend-header>

<!-- Subheader -->
<div class="sticky bg-primary shadow-sm shadow-primary top-20 w-full z-20">
  <div class="max-w-screen-xl mx-auto p-4 text-white">
    <div class="flex justify-between">
      <div class="flex flex-col">
        <span class="text-2xl">{{ label() }}</span>
        <span class="text-sm text-gray-200">
          <!-- See README#possibly-undefined -->
          {{ workshop()?.locationName }}
        </span>
      </div>
      <div>
        @if (workshop(); as workshop) {
          <button
            class="button-outline button-outline-secondary mt-2 sm:mt-0"
            [matTooltip]="tooltipText()"
            [i18nRouterLink]="['/cart/add/workshop', workshop.id]"
            [disabled]="!isWorkshopAvailable()"
            i18n
          >
            Enroll
          </button>
        }
      </div>
    </div>
    <!-- <div>
      <div class="flex gap-4 items-end">
        <a i18n class="text-lg cursor-pointer" (click)="navigate.emit('practical')">
          Practical
        </a>
        <a i18n class="text-lg cursor-pointer" (click)="navigate.emit('included')">
          Included
        </a>
        <a class="text-lg cursor-pointer" (click)="navigate.emit('faq')">FAQ</a>
      </div>
    </div> -->
  </div>
</div>
